<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">Glamyo Patient List</h1>
	    </div>
	   

    </div>

    <div class="container-fluid px-4 pt-4 card">
       
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadGlamyoPatientList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button></div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Name</th>
                        <th>Patient Id</th>
                        <th>Contact Number</th>
                        <th>Circle Name</th>
                        <th>Wallet</th>
                        <th *ngIf="myrole=='1'" style="width: 100px;">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of usersList;let index = index;">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>{{user.lead_type}}</td>
                        <td>{{user.pt_name}}</td>
                        <td>{{user.glamyo_patient_id}}</td>
                        <td>{{user.phone}}</td>
                        <td>{{user.leadCircleName}}</td>
                        <td>{{user.wallet}}</td>
                        <td *ngIf="myrole=='1'">
                            <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item cursor-pointer" (click)="showModal(user.glamyo_patient_id)"><i
                                            class="fa fa-edit"></i> Update</a>
                                </div>
                            </div>
                        </td>
                    </tr>    
                    <tr *ngIf="loading">
                        <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !usersList.length">
                        <td colspan="20" ><i class="far fa-frown"></i> Users not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


          </div>
</div>

<!--Modal Update For Wallet-->
<div class="modal fade" id="myModal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>Update Wallet</span>
                </h4>
                <button type="button" class="close" (click)="hideModal()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="walletForm" (submit)="createWallet()">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-sm-12">
                                <label class="form-label">Wallet</label>
                                <input type="text" formControlName="wallet" class="form-control" />
                            </div>
                        </div>
                    </div><br>
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span>Update Wallet</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>